import React from 'react';
import PropTypes from 'prop-types';
// material
import { Box } from '@mui/material';
import publicUrl from 'utils/publicUrl';

// ----------------------------------------------------------------------

Logo.propTypes = {
  sx: PropTypes.object
};

export default function Logo({ sx, width = 80 * 1.085, height = 80 }) {
  return (
    <Box
      component="img"
      src={publicUrl('/static/PTTEP-logo.png')}
      sx={{
        width,
        height,
        ...sx
      }}
    />
  );
}
